import { useDispatch, useSelector } from 'react-redux';
import styles from '../css/List.module.css';
import ImageAlbum from './ImageAlbum';
import { photofolioActions, photofolioSelector } from '../redux/reducers/reducers';

export function List() {
    const { albums, toggle, albumToggle } = useSelector(photofolioSelector);
    const dispatch = useDispatch();

    const handleToggle = () => {
        dispatch(photofolioActions.handleToggle());
    };

    const handleAlbumToggle = () => {
        dispatch(photofolioActions.handleAlbumToggle());

    };

    const setcurrentAlbumOBJ = (index) => {
        dispatch(photofolioActions.setcurrentAlbumOBJ(index));
    };

    const currImagesForSlidesHandle = (album) => {
        dispatch(photofolioActions.currImagesForSlidesHandle(album));
    };

    return (
        <div className={styles.container}>

            <div className={styles.upperBox}>
                <h4>Your Albums</h4>
                {toggle ? (
                    <button onClick={handleToggle} id={styles.cancel}>Cancel</button>
                ) : (
                    <button onClick={handleToggle} id={styles.addAlbum}>Add album</button>
                )}
            </div>

            <div className={styles.albumBox}>
                {albums && albums.map((album, index) => (
                    <ImageAlbum
                        key={index}
                        album={album}
                        onClick={handleAlbumToggle}
                        dispalyImages={() => setcurrentAlbumOBJ(index)}
                        index={index}
                        currImagesForSlidesHandle={() => currImagesForSlidesHandle(album)}
                    />
                ))}
            </div>

        </div>
    );
}
